// components/Delivery/DeliveryHeader.jsx
export default function DeliveryHeader({ title, subtitle }) {
  return (
    <header>
      <h2 className="mb-2 text-2xl font-bold md:text-3xl text-blue">{title}</h2>
      {subtitle && <p className="text-gray-600">{subtitle}</p>}
    </header>
  );
}